import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'pickright-label',
    templateUrl: './control-label.component.html'
})
export class PickrightLabelComponent implements OnInit {
    @Input('label') label: string;
    @Input('required') required: boolean = false;
    constructor() { }

    ngOnInit(): void { }

}
